import styles from './ToolBar.module.scss'
import { ScoopTooltip } from '../ui'

const ToolBarIcon = ({
    icon: Icon,
    label,
    tooltipTitle,
    tooltipPlacement,
    tooltipOpen,
    onClick,
    onMouseEnter,
    selected,
    disabled,
    disabledText,
}) => {
    return (
        <ScoopTooltip
            title={disabled ? disabledText : tooltipTitle}
            placement={tooltipPlacement}
            open={tooltipOpen === label}
        >
            <div
                onClick={!disabled ? onClick : null}
                className={`${styles.toolbarButtonIcon} ${selected ? styles.selectedIcon : ''} ${disabled ? styles.toolbarButtonIconDisabled : ''}`}
                onMouseEnter={onMouseEnter}
            >
                <Icon size={20} />
            </div>
        </ScoopTooltip>
    )
}
export default ToolBarIcon
